import { Form, Input, Space } from 'antd';
import { LogikFieldsEnum } from '../../../shared/logik/constants/fields.constant';
import { LogikFormSetItem } from '../../../shared/logik/components/LogikFormSetItem';
import React, { useRef, useState } from 'react';
import { isEqual, uniq } from 'lodash';
import { MinusCircleOutlined } from '@ant-design/icons';
import styles from './CustomRequestRowContent.module.scss';
import { getMoneyInputValidators, MoneyInput, MoneyInputRef } from '../../../shared/antd/components/MoneyInput';
import { LogikInput } from '../../../shared/logik/components/LogikInput';
import { useFieldValue } from '../../../shared/logik/hooks/field.hooks';
import { LogikComplexFormItem } from '../../../shared/logik/components/LogikComplexFormItem';

type CustomRequestImplProps = {
    index: number;
    onRemove: () => void;
};

const CustomRequestRowContentImpl = ({ index, onRemove }: CustomRequestImplProps): JSX.Element => {
    const moneyRef = useRef<MoneyInputRef>(null);
    const userProfile = useFieldValue<string>(LogikFieldsEnum.userProfile);

    const [labelErrors, setLabelErrors] = useState<React.ReactNode[]>([]);
    const [amountErrors, setAmountErrors] = useState<React.ReactNode[]>([]);

    const [labelWarnings, setLabelWarnings] = useState<React.ReactNode[]>([]);
    const [amountWarnings, setAmountWarnings] = useState<React.ReactNode[]>([]);

    const combinedErrors = uniq([...labelErrors, ...amountErrors]);
    const combinedWarnings = uniq([...labelWarnings, ...amountWarnings]);

    const label = (
        <span className={styles['custom-req-label']}>
            <MinusCircleOutlined
                className={styles['custom-req-remove-btn']}
                onClick={userProfile !== 'Customer' ? onRemove : () => {}}
            />
        </span>
    );

    return (
        <>
            <Form.Item name={[index]} hidden={true}>
                <Input type='hidden' />
            </Form.Item>

            <>
                <LogikComplexFormItem
                    label={label}
                    labelCol={{ span: 1 }}
                    className={'direction-horizontal hide-errors hide-status-success hide-status-warning'}
                    extra={''}
                    help={''}
                    errors={combinedErrors}
                    warnings={combinedWarnings}>
                    <Space.Compact>
                        <LogikFormSetItem
                            labelCol={{ span: 9 }}
                            hideErrors
                            hideWarnings
                            logikName={LogikFieldsEnum.set_of_custom_requests_desc}
                            index={index}
                            setName={LogikFieldsEnum.set_of_custom_requests}
                            rules={[
                                {
                                    required: true,
                                    message: `Description is required`,
                                },
                            ]}
                            updateOnBlur
                            onErrors={setLabelErrors}
                            onWarnings={setLabelWarnings}
                            label={undefined}
                            hasFeedback={false}
                            className={'hide-errors'}>
                            <LogikInput placeholder={'Description'} autoFocus />
                        </LogikFormSetItem>

                        <LogikFormSetItem
                            hideErrors
                            hideWarnings
                            logikName={LogikFieldsEnum.set_of_custom_requests_amt}
                            index={index}
                            setName={LogikFieldsEnum.set_of_custom_requests}
                            messageVariables={{ name: `Amount` }}
                            rules={getMoneyInputValidators(moneyRef)}
                            updateOnBlur
                            onErrors={setAmountErrors}
                            onWarnings={setAmountWarnings}
                            hasFeedback={false}>
                            <MoneyInput placeholder={'Amount'} ref={moneyRef} />
                        </LogikFormSetItem>
                    </Space.Compact>
                </LogikComplexFormItem>
            </>
        </>
    );
};

export const CustomRequestRowContent = React.memo(CustomRequestRowContentImpl, (prev, next) => isEqual(prev, next));
